export const setPromotion = (value, page, limit, count, promos) => {
    return {
      type: 'SET_PROMOTION',
      payload: { data: value, page, limit, count, promos }
    };
  };

  export const setActivePromotion = (value) => {
    return {
      type: 'SET_ACTIVE_PROMOTION',
      payload: { data: value }
    };
  };